import { render, staticRenderFns } from "./telefono.vue?vue&type=template&id=faff70ca&"
import script from "./telefono.vue?vue&type=script&lang=ts&"
export * from "./telefono.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports